export const tokens = {
  // Cores primárias
  primaryGradient: 'linear-gradient(135deg, #162C52 0%, #1D4173 100%)',
  primaryGradientHover: 'linear-gradient(135deg, #1A345C 0%, #224B84 100%)',
  primaryColor: '#1F467E',
  primaryLight: '#e9f5ff',

  // Cores de texto
  textPrimary: '#212529',
  textSecondary: '#495057',
  textMuted: '#6c757d',
  textHint: '#687078',

  // Cores de estado
  errorColor: '#dc3545',
  successColor: '#28a745',
  warningColor: '#ffc107',
  warningBg: '#fff8e1',

  // Bordas
  borderDefault: '#ced4da',
  borderLight: '#e9ecef',
  borderError: '#dc3545',
  borderFocus: '#80bdff',

  // Backgrounds
  bgWhite: '#ffffff',
  bgLight: '#f8f9fa',
  bgOverlay: 'rgba(255, 255, 255, 0.7)',
  bgImageOverlay: 'rgba(0, 0, 0, 0.8)',
  bgScrollTrack: '#f1f1f1',
  bgScrollThumb: '#c1c1c1',
  bgScrollThumbHover: '#a8a8a8',
  bgDisabled: '#5a5a5a',

  // Espaçamentos
  spacingXs: '0.25rem',
  spacingSm: '0.5rem',
  spacingMd: '0.75rem',
  spacingLg: '1rem',
  spacingXl: '1.5rem',
  spacingXxl: '2rem',

  // Border radius
  radiusSm: '4px',
  radiusMd: '6px',
  radiusLg: '8px',
  radiusXl: '12px',
  radiusFull: '50%',

  // Font sizes
  fontXs: '0.75rem',
  fontSm: '0.85rem',
  fontMd: '0.9rem',
  fontBase: '0.95rem',
  fontLg: '1rem',
  fontXl: '1.2rem',
  fontXxl: '1.25rem',

  // Shadows
  shadowSm: '0 1px 3px rgba(0, 0, 0, 0.08)',
  shadowMd: '0 4px 12px rgba(0, 0, 0, 0.1)',
  shadowLg: '0 8px 30px rgba(0, 0, 0, 0.12)',
  shadowImage: '0 4px 20px rgba(0, 0, 0, 0.3)',

  // Transitions
  transitionFast: '0.15s ease-in-out',
  transitionBase: '0.2s ease',
  transitionSlow: '0.3s ease',

  // Z-index
  zModal: 1050,
  zOverlay: 1000,
  zFooter: 1049,
  zImagePreview: 2000,

  // Breakpoints
  breakpointSm: '480px',
  breakpointMd: '768px',
  breakpointLg: '1024px',
  breakpointXl: '1200px',

  // Font family
  fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
} as const;

export type Tokens = typeof tokens;
